import React, { useEffect, useState } from 'react'
import { TranslationProvider } from '../shared/TranslationProvider'
import translations from './locales.json'
import ActionPlanInfo from './ActionPlanInfo'
import ActiveTile from './TrackTileComponents/ActiveTile'
import StepMenu from './StepMenu'
import { ActionPlanProvider, useActionPlan } from './ActionPlanProvider'
import { Provider } from 'react-redux'
import { store } from '~/lib/store'
import {
  setGoal,
  setGoalKey,
  setDesiredTimeline,
  setProgressPercent,
  setTrackerSectionInfo,
} from './ActionPlanSlice'
import { useIsMobile } from '~/hooks/useMediaQuery'
import { getApi } from '~/util/api'
import MobileMenu from './MobileMenu'

const Index = ({ ...props }) => {
  return (
    <Provider store={store}>
      <ActionPlanProvider {...props}>
        <ActionPlan {...props} />
      </ActionPlanProvider>
    </Provider>
  )
}
export default Index

export const getUserTrackerSections = async () => {
  getApi()
    .get('/tracker/get_tracker_sections')
    .then((response) => {
      if (response.status == 200) {
        const data = response.data
        store.dispatch(setTrackerSectionInfo(data.trackerSections))
        store.dispatch(setProgressPercent(data.trackerProgress))
        if (data.trackerGoal != null) store.dispatch(setGoal(data.trackerGoal))
        if (data.trackerGoalKey != null)
          store.dispatch(setGoalKey(data.trackerGoalKey))
        if (data.trackerTimeline != null)
          store.dispatch(setDesiredTimeline(data.trackerTimeline))
        return
      } else {
        throw new Error('json request failed')
      }
    })
    .catch((error) => {
      console.error('json request failed', error)
      return
    })
}

const ActionPlan = ({ current_user }) => {
  const [activeTab, setActiveTab] = useState()
  const { trackerSectionInfo, goal, timeline } = useActionPlan()
  const isMobile = useIsMobile()

  useEffect(() => {
    getUserTrackerSections()
  }, [])

  const totalSteps = React.useMemo(
    () => JSON.parse(JSON.stringify([...trackerSectionInfo])),
    [trackerSectionInfo],
  )

  return (
    <TranslationProvider
      locale={current_user.locale}
      translations={translations}
      scope={'javascript.components.ActionPlan'}
    >
      {/* CTS-9291 — visual baseline root (op_next_gen /orientation/action_plan) */}
      <div className="m-4 md:m-10" data-testid="orientation-action-plan">
        <ActionPlanInfo goal={goal} timeline={timeline} />
        {isMobile && activeTab ? (
          <MobileMenu
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            totalSteps={totalSteps}
          />
        ) : (
          <DesktopMenu
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            totalSteps={totalSteps}
          />
        )}
      </div>
    </TranslationProvider>
  )
}

const DesktopMenu = ({ activeTab, setActiveTab, totalSteps }) => {
  return (
    <>
      <StepMenu
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        totalSteps={totalSteps}
      />
      {activeTab && <ActiveTile tileInfo={activeTab} />}
    </>
  )
}
